import {Button,Grid,TextField} from '@material-ui/core';
import React, {useState} from 'react';
import './Main.css';
import MenuAppBar from '../components/MenuAppBar';
import Footer from '../components/Footer.js';
import Card from '../components/Card';
import Form from '../components/Form';
import CardList from '../components/CardList'
import {BrowserRouter as Link,Router,Switch,Route} from 'react-router-dom';
import { FormatListNumberedTwoTone } from '@material-ui/icons';

function Main() {
  const [inputText , setInputText] = useState("");
  const [note, setNote] = useState([]);
  return (
    <div className="App">
      <MenuAppBar pageTitle="Notes" />
      <h1>Notes app </h1>
      <Form setInputText={setInputText} note={note} setNote={setNote} inputText={inputText}/>
      <CardList note={note} setNote={setNote}/>
      <Footer />
    </div>
  );
}

export default Main;
